export default __webpack_public_path__ + "static/media/ic_aigisos_24.bd896aa0.svg";